import { theme } from '@noths/polaris-client-ribbons-base';
import { pxToRem } from '@noths/polaris-client-styles';
import { palette } from '@noths/polaris-design-system-theme-brand2026customer';
import { css } from 'styled-components';

import { baseButton, baseLink } from '../styles/base.styles';

const { fonts, responsiveText } = theme;

const hyperButtonBase = css`
  padding: 0;
  max-width: ${pxToRem(462)};
  ${responsiveText.BODY.MD};
  font-family: ${fonts.PRIMARY_REGULAR.family};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};
  text-decoration: underline;
  color: ${palette.deepPurpleBase};
  margin: ${pxToRem(2)};

  &.focus-visible:focus {
    border-radius: ${pxToRem(4)};
  }
`;

export const hyperButtonLink = css`
  ${baseLink}
  ${hyperButtonBase}
`;

export const hyperButton = css`
  ${baseButton}
  ${hyperButtonBase}
`;
